import {Color} from '@benchling/nucleus-ui';
import {StyleSheet, css} from 'aphrodite';
import React from 'react';

import {assert} from 'Asserts';
import * as FileConstants from 'folder-items/FileConstants';
import {
  ComplexPolymerSchemaConfigGraphQL,
  isOligoConjugateConfigGraphQLType,
  isOligoDuplexConfigGraphQLType,
} from 'modbio/complex-polymers/ComplexPolymerUtil';
import {QueryingOligoConjugateOligoMap} from 'modbio/complex-polymers/tabs/OligoConjugatePolymerMap';
import {QueryingOligoDuplexOligoMap} from 'modbio/complex-polymers/tabs/OligoDuplexPolymerMap';

function isTagEmpty(tag: FileConstants.SchemaTag | null | undefined): boolean {
  return tag == null || tag.targetFiles == null || tag.targetFiles.length === 0;
}
export interface CreateComplexPolymerOligoPreviewProps {
  complexPolymerTags: Array<FileConstants.SchemaTag>;
  complexPolymerConfig: ComplexPolymerSchemaConfigGraphQL;
  offset: number | null;
}

export default function CreateComplexPolymerOligoPreview({
  complexPolymerTags,
  complexPolymerConfig,
  offset,
}: CreateComplexPolymerOligoPreviewProps): JSX.Element | null {
  if (isOligoConjugateConfigGraphQLType(complexPolymerConfig)) {
    const oligoFieldId = complexPolymerConfig.oligoSchemaField.id;
    const oligoTag = complexPolymerTags.find((tag) => tag.tagSchemaField.apiId === oligoFieldId);

    if (isTagEmpty(oligoTag)) {
      return <div className={css(styles.emptyOligoMap)}>Select an oligo to preview backbone</div>;
    }
    const oligoId = oligoTag!.targetFiles![0].id;
    return <QueryingOligoConjugateOligoMap oligoId={oligoId} />;
  } else if (isOligoDuplexConfigGraphQLType(complexPolymerConfig)) {
    const forwardOligoTag = complexPolymerTags.find(
      (tag) => tag.tagSchemaField.apiId === complexPolymerConfig.forwardStrandSchemaField.id
    );
    const reverseOligoTag = complexPolymerTags.find(
      (tag) => tag.tagSchemaField.apiId === complexPolymerConfig.reverseStrandSchemaField.id
    );

    if (isTagEmpty(forwardOligoTag) || isTagEmpty(reverseOligoTag)) {
      return <div className={css(styles.emptyOligoMap)}>Select oligos to preview backbone</div>;
    }

    assert(offset != null, 'Expected oligo duplex to have offset');

    return (
      <QueryingOligoDuplexOligoMap
        oligoIds={[forwardOligoTag!.targetFiles![0].id, reverseOligoTag!.targetFiles![0].id]}
        offset={offset}
      />
    );
  }

  return null;
}

const styles = StyleSheet.create({
  emptyOligoMap: {
    height: '130px',
    border: `1px solid ${Color.GRAY_200}`,
    borderRadius: '4px',
    marginBottom: '10px',
    background: Color.GRAY_200,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
});
